<template>
  <div class="HelpText">
    <div class="container">
      <div class="row">
        <div
          v-if="$context.cmsEntry.under_accordions_text"
          class="help-text text-center my-6 wysiwyg"
          v-html="$context.cmsEntry.under_accordions_text"
        />
        <div v-else-if="!$context.isEmployeeSite" class="col">
          <p class="help-text text-center my-6">
            HAI BISOGNO DI AIUTO?
            <br />
            <br />
            Contatta il nostro team di esperti al numero 02-44412661 o usa la
            chat.
            <br />
            Servizio disponibile dal Lunedi al Venerdì dalle 09:00 alle 20:00 e
            il Sabato dalle 10:00 alle 18:00.
            <br />
            <br />
            Se hai riscontrato un’anomalia o malfunzionamento del sito,
            <br />
            segnala al nostro reparto tecnico scrivendo a
            <a href="mailto:support-df@stellantis-finance.com">
              support-df@stellantis-finance.com
            </a>
          </p>
        </div>
        <div v-else class="col">
          <p class="help-text text-center my-6">
            In caso di anomalie, problemi del sito, o necessità di informazioni
            sul prodotto che non sono adeguatamente chiarite nelle FAQ,
            <br />
            scrivici a
            <a href="mailto:noleggiodipendenti@stellantis-finance.com">
              noleggiodipendenti@stellantis-finance.com
            </a>
            indicando nell'oggetto la dicitura "Problema tecnico" in caso di
            anomalie e bug,
            <br />
            oppure "Richiesta informazioni". Risponderemo nel più breve tempo
            possibile
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpText',
  // functional: true,
};
</script>

<style lang="scss" scoped>
.HelpText {
  a {
    color: var(--brand-color);
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
